import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FormDrawer from "src/components/Form/FormDrawer";
import { useAppSelector } from "src/store";
import { createBrandSaga } from "src/store/brands/saga";
import * as Yup from "yup";
import { BrandDetailDto } from "src/store/brands/type";

const BrandCreateForm = ({
  onHide,
  open,
  onSuccessClick,
  parentbrand,
}: {
  parentbrand: BrandDetailDto;
  onSuccessClick: (message: string) => void;
  onHide: () => void;
  open: boolean;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const languages = useAppSelector((s) => s.language.languages);
  return (
    <React.Fragment>
      <FormDrawer
        drawerProps={{
          isOpen: open,
          onHide: onHide,
          title: t("Brand.SubbrandCreateFormTitle", {
            name: parentbrand.Name,
          }).toString(),
        }}
        onHide={onHide}
        loader
        initialValues={{
          Name: "",
          ParentBrandId: parentbrand.Id,
          SectorId: parentbrand.SectorId,
          Translates: languages.map((x) => {
            return { LanguageId: x.EnumId, Name: "" };
          }),
        }}
        onSubmit={(values) => {
          dispatch(
            createBrandSaga({
              payload: {
                onSuccess: (message, payload) => {
                  onHide();
                  onSuccessClick(message);
                },
                onError: (message) => {
                  toast.error(message, {
                    theme: "colored",
                  });
                },
              },
              body: values,
            })
          );
        }}
        validationSchema={Yup.object().shape({
          Name: Yup.string().required(t("Validation.Required").toString()),
          Translates: Yup.array(
            Yup.object({
              Name: Yup.string().required(t("Validation.Required").toString()),
            })
          ),
        })}
        multilanguageinputs={[
          {
            field: "Name",
            label: t("Brand.Name").toString(),
          },
        ]}
        // inputs={[
        //   {
        //     onHiding(values) {
        //       return parentbrand ? true : false;
        //     },
        //     field: "SectorId",
        //     label: t("Brand.Sector").toString(),
        //     type: "select",
        //     lookup: {
        //       labelKey: "Name",
        //       valueKey: "Id",
        //       options: sectors,
        //     },
        //   },
        // ]}
      />
    </React.Fragment>
  );
};
export default BrandCreateForm;
